import { render } from "./ImportStock.vue?vue&type=template&id=1039784d&scoped=true&ts=true"
import script from "./ImportStock.vue?vue&type=script&lang=ts"
export * from "./ImportStock.vue?vue&type=script&lang=ts"

import "./ImportStock.vue?vue&type=style&index=0&id=1039784d&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1039784d"]])

export default __exports__